module.exports = __webpack_public_path__ + "img/ppc.f606cd14.png";